var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "filter__slider" },
    [
      _c("vue-slider", {
        attrs: {
          min: _vm.min,
          max: _vm.max,
          "enable-cross": false,
          tooltip: "always"
        },
        on: { "drag-end": _vm.changedValue },
        scopedSlots: _vm._u([
          {
            key: "tooltip",
            fn: function(ref) {
              var value = ref.value
              return [
                _c("div", { staticClass: "vue-slider-dot-tooltip-inner" }, [
                  _vm._v(_vm._s(value + " " + _vm.unit))
                ])
              ]
            }
          }
        ]),
        model: {
          value: _vm.initValue,
          callback: function($$v) {
            _vm.initValue = $$v
          },
          expression: "initValue"
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }